import {
  DISPLAY_CENTER_SAVE_BUTTON,
  DISPLAY_CENTERS_DROPDOWN_LIST,
  DISPLAY_THEMES,
  DISPLAY_TIME_ZONES,
  SET_CAN_ASSIGN_TAG,
  SET_CAN_DELETE_TAG,
  SET_CARDS,
  SET_CARD_SELECTION,
  SET_IS_ADDING_TAG,
  SET_IS_NEW_TOURNAMENT,
  SET_LOCATION_CERTIFICATION_NUMBER,
  SET_STRIPE_ACCOUNT_SELECTION,
  SET_STRIPE_ACCOUNTS,
  SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE,
  SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE,
  SET_TOURNAMENT_LOCATION_EDITING,
  SET_TOURNAMENT_LOCATION_NAME_VALUE,
  SET_TOURNAMENT_LOCATION_SEARCH_RESULTS,
  SET_TOURNAMENT_LOCATIONS_IN_STATE,
  SET_TOURNAMENT_TAGS,
  SET_TAG_INDEX,
  SET_AVAILABLE_TAGS,
  SET_IS_SUPER_USER
} from './constants';

export const displayCenterSaveButton = saveable => ({
  type: DISPLAY_CENTER_SAVE_BUTTON,
  payload: saveable
});

export const displayCentersDropdownList = selectable => ({
  type: DISPLAY_CENTERS_DROPDOWN_LIST,
  payload: selectable
});

export const displayThemes = data => ({
  type: DISPLAY_THEMES,
  payload: data
});

export const displayTimeZones = data => ({
  type: DISPLAY_TIME_ZONES,
  payload: data
});

export const handleLocationNameChange = (locationName) => ({
  type: SET_TOURNAMENT_LOCATION_NAME_VALUE,
  payload: locationName
});

export const setCanAssignTag = data => ({
  type: SET_CAN_ASSIGN_TAG,
  payload: data
});

export const setCanDeleteTag = data => ({
  type: SET_CAN_DELETE_TAG,
  payload: data
});

export const setCards = data => ({
  type: SET_CARDS,
  payload: data
});

export const setCardSelection = data => ({
  type: SET_CARD_SELECTION,
  payload: data
});

export const setDataExportOptions = options => ({
  type: SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE,
  payload: options
});

export const setExportSelection = option => ({
  type: SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE,
  payload: option
});

export const setIsAddingTag = data => ({
  type: SET_IS_ADDING_TAG,
  payload: data
});

export const setIsNewTournament = data => ({
  type: SET_IS_NEW_TOURNAMENT,
  payload: data
});

export const setLocationCertificationNumber = certificationNumber => ({
  type: SET_LOCATION_CERTIFICATION_NUMBER,
  payload: certificationNumber
});

export const setStripeAccounts = options => ({
  type: SET_STRIPE_ACCOUNTS,
  payload: options
});

export const setStripeAccountSelection = option => ({
  type: SET_STRIPE_ACCOUNT_SELECTION,
  payload: option
});

export const setTagIndex = data => ({
  type: SET_TAG_INDEX,
  payload: data
});

export const setAvailableTags = data => ({
  type: SET_AVAILABLE_TAGS,
  payload: data
});

export const setTournamentLocations = locations => ({
  type: SET_TOURNAMENT_LOCATIONS_IN_STATE,
  payload: locations
});

export const setTournamentLocationSearchResults = locationSearchResults => ({
  type: SET_TOURNAMENT_LOCATION_SEARCH_RESULTS,
  payload: locationSearchResults
});

export const setTournamentTags = data => ({
  type: SET_TOURNAMENT_TAGS,
  payload: data
});

export const toggleTournamentLocationEditing = id => ({
  type: SET_TOURNAMENT_LOCATION_EDITING,
  payload: id
});

export const setIsSuperUser = data => ({
  type: SET_IS_SUPER_USER,
  payload: data
});



// WEBPACK FOOTER //
// ./src/features/tournament/general/actionTypes.js